export enum CompareQuotesUrlParam {
    QuoteIds = 'quoteIds',
    ExpiringPolicyFileId = 'expiringPolicyFileId',
}
